import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import TimePicker from 'material-ui/TimePicker';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import moment from 'moment'

import {closeAddAvailableTimeSlotForm, updateAvailableTimeSlotField, updateAvailableTimeSlot, deleteAvailableTimeSlot, updateLastTime} from '../../actions/availableTimeSlots'

class AddAvailableTimeSlot extends Component {

  static defaultProps = {
  }

  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  componentDidMount() {
  }

  closeDialog() {
    const { dispatch } = this.props
    dispatch(closeAddAvailableTimeSlotForm())
  }

  updateAvailableTimeSlot() {
    const { dispatch } = this.props
    dispatch(updateAvailableTimeSlot(this.props.availableTimeSlot))
    dispatch(updateLastTime(this.props.availableTimeSlot.startDate, this.props.availableTimeSlot.endDate))
  }

  updateLastTime() {
    const { dispatch } = this.props
    dispatch(updateLastTime(this.props.availableTimeSlot.startDate, this.props.availableTimeSlot.endDate))
  }

  deleteAvailableTimeSlot() {
    const { dispatch } = this.props
    dispatch(deleteAvailableTimeSlot(this.props.availableTimeSlot))
  }

  updateAvailableTimeSlotField(name, event, date) {
    const { dispatch } = this.props
    dispatch(updateAvailableTimeSlotField(name, date))
  }

  
  render() {

    if (this.props.availableTimeSlot) {
      
      var actions = [
        <FlatButton
          label="Cancel"
          primary={true}
          onClick={this.closeDialog.bind(this)}
        />,
        <FlatButton
					id="add_time_slot"
          label={this.props.availableTimeSlot._id == null ? "Add Time Slot" : "Update"}
          primary={true}
          onClick={this.updateAvailableTimeSlot.bind(this)}
        />,
      ];

      if (this.props.availableTimeSlot._id != null) {
        actions.push(<FlatButton
          label="Delete"
          secondary={true}
          onClick={this.deleteAvailableTimeSlot.bind(this)}
        />)
      }

      return (<Dialog
        actions={actions}
        title="Available Time Slot"
        modal={true}
        open={this.props.availableTimeSlot != null}>
        <TimePicker
          name="startDateTime"
          format="ampm"
          hintText="Start Time"
          value={moment(this.props.availableTimeSlot.startDate).toDate()}
          onChange={this.updateAvailableTimeSlotField.bind(this, 'startDate')}
        />
        <br />
        <TimePicker
          name="endDateTime"
          format="ampm"
          hintText="End Time"
          value={moment(this.props.availableTimeSlot.endDate).toDate()}
          onChange={this.updateAvailableTimeSlotField.bind(this, 'endDate')}
        />
      </Dialog>)
    } else {
      return (<div />)
    }
  }
}

const mapStateToProps = state => {
  return state.locationsReducer
}

export default withRouter(
  connect(mapStateToProps)(AddAvailableTimeSlot)
);



// WEBPACK FOOTER //
// ./src/components/locations/AddAvailableTimeSlot.js